import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "sender" };
const _hoisted_2 = {
    key: 0,
    class: "body"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "read" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 1 };
import MessageForm from "./MessageForm.vue";
import useMessage from "../../composables/message/useMessage";
import { formatDateTimeWithoutSeconds } from "@/utils/utils";
import { watch, ref, onMounted, onUpdated } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Messages',
    props: {
        fromUserId: {},
        toUserId: {}
    },
    setup(__props) {
        const { messages, fromUser, toUser, fetchByUserIds } = useMessage();
        const messageListContainer = ref(null);
        const props = __props;
        const scrollToLatestMessage = () => {
            if (messageListContainer.value) {
                const element = messageListContainer.value;
                element.scrollTop = element.scrollHeight;
            }
        };
        onMounted(() => {
            fetchByUserIds(props.fromUserId, props.toUserId);
            scrollToLatestMessage();
        });
        watch(() => props.toUserId, () => {
            fetchByUserIds(props.fromUserId, props.toUserId);
            scrollToLatestMessage();
        });
        watch(() => props.fromUserId, () => {
            fetchByUserIds(props.fromUserId, props.toUserId);
            scrollToLatestMessage();
        });
        onUpdated(() => {
            scrollToLatestMessage();
        });
        const sent = () => {
            fetchByUserIds(props.fromUserId, props.toUserId);
            scrollToLatestMessage();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(_unref(fromUser).name) + " さんと " + _toDisplayString(_unref(toUser).name) + " さんのやりとり", 1)
                ]),
                (_unref(messages).length != 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "message-list",
                        ref_key: "messageListContainer",
                        ref: messageListContainer
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(`message ${message.toUserId == _ctx.toUserId ? 'right' : 'left'}`),
                                key: index
                            }, [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(message.fromUserName), 1),
                                (message.attachmentUrl == '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(message.text), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("a", {
                                            href: message.attachmentUrl,
                                            target: "_blank"
                                        }, _toDisplayString(message.text), 9, _hoisted_4)
                                    ])),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("p", null, "送信日時: " + _toDisplayString(_unref(formatDateTimeWithoutSeconds)(message.sentTime)), 1),
                                    (message.read)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "既読"))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_7, "未読"))
                                ])
                            ], 2));
                        }), 128))
                    ], 512))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[0] || (_cache[0] = [
                        _createElementVNode("p", null, "メッセージはありません", -1)
                    ]))),
                (_ctx.fromUserId === 0)
                    ? (_openBlock(), _createBlock(MessageForm, {
                        key: 2,
                        "to-user-id": props.toUserId,
                        onSent: sent
                    }, null, 8, ["to-user-id"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
